import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { BaseEntity } from '../base/BaseEntity'
import { modelOptions, Prop } from '@typegoose/typegoose'
import type { ViewCountKeyEnum } from './ViewCountKeyEnum'

@ObjectType()
@InputType('ViewCountInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class ViewCount extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  key: ViewCountKeyEnum

  @Field(() => String)
  @Prop({ type: String })
  value: string

  @Field(() => Float)
  @Prop({ type: Number, default: 0 })
  count: number
}
